module.exports = __webpack_public_path__ + "static/media/detail2.69607567.jpg";